import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { completeTradovateOAuth } from "wasp/client/operations";
import { COMPLETE_PARAM } from "./tradovateOAuthBinding";

// Tickets déjà présentés, au niveau du module : survit au double montage de
// StrictMode et à un rendu répété, sans quoi le code serait échangé deux fois
// et le second échange afficherait une erreur après une connexion réussie.
const consumed = new Set<string>();

/**
 * Termine un flux OAuth Tradovate LIÉ (?tradovateComplete=<ticket>), voir
 * tradovateOAuthBinding.ts. Monté une seule fois, à la racine de l'app.
 *
 * Le ticket est retiré de l'URL avant l'appel : un rafraîchissement ne le
 * rejoue pas. Le serveur rend le même chemin que le callback historique
 * (`?tradovateImport=…` ou `?tradovateError=…`), que les écrans existants
 * savent déjà traiter.
 */
export function useTradovateOAuthCompletion(enabled: boolean): void {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const ticket = searchParams.get(COMPLETE_PARAM);

  useEffect(() => {
    if (!enabled || !ticket || consumed.has(ticket)) return;
    consumed.add(ticket);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(COMPLETE_PARAM);
        return next;
      },
      { replace: true },
    );
    completeTradovateOAuth({ ticket })
      .then(({ redirectPath }) => navigate(redirectPath, { replace: true }))
      .catch(() => navigate("/trading-accounts?tradovateError=unknown", { replace: true }));
  }, [enabled, ticket, setSearchParams, navigate]);
}
